import { useEffect, useState } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import MedicalHistoryService from "../../../../Services/MedicalHistoryService";
import AllergyDetails from "../../ConsultationNotes/VitalTabs/MedicalHistory/AllergyDetails";
import PastMedicalHistory from "../../ConsultationNotes/VitalTabs/MedicalHistory/PastMedicalHistory";
import SurgicalHistory from "../../ConsultationNotes/VitalTabs/MedicalHistory/SurgicalHistory";
import FamilyHistory from "../../ConsultationNotes/VitalTabs/MedicalHistory/FamilyHistory";
import SocialHistory from "../../ConsultationNotes/VitalTabs/MedicalHistory/SocialHistory";
import ChronicCondition from "../../ConsultationNotes/VitalTabs/MedicalHistory/ChronicCondition";
import Vaccines from "../../ConsultationNotes/VitalTabs/MedicalHistory/Vaccinations";
import Medication from "../../ConsultationNotes/VitalTabs/MedicalHistory/Medication";

export default function MedicalHistory({ patientId }) {
  return (
    <>
      <div className={`border grid  grid-cols-4 gap-2 p-2`}>
        <AllergyDetails permissionData={true} />
        <PastMedicalHistory permissionData={true} />
        <SurgicalHistory permissionData={true} />
        <FamilyHistory permissionData={true} />
        <SocialHistory permissionData={true} />
        <Medication permissionData={true} />
        <ChronicCondition permissionData={true  } />
        <Vaccines permissionData={true} />
        {/* <EmergencyData /> */}
      </div>
    </>
  );
}
